/**
 * Twilio Spend Hook
 * TanStack Query hook for fetching Twilio billing data
 */

import { useQuery } from '@tanstack/react-query';
import { getTwilioSpend } from '../api';

/** Query key factory */
export const twilioSpendKeys = {
  all: ['twilio-spend'] as const,
  summary: () => [...twilioSpendKeys.all, 'summary'] as const,
};

/**
 * Hook to fetch Twilio spend data
 * Refreshes every 5 minutes
 */
export function useTwilioSpend() {
  return useQuery({
    queryKey: twilioSpendKeys.summary(),
    queryFn: getTwilioSpend,
    staleTime: 5 * 60 * 1000, // 5 minutes
    refetchInterval: 5 * 60 * 1000, // Auto-refresh every 5 minutes
  });
}
